import { createContext, useContext } from 'react';
import noop from 'utils/noop';

type ViewContextState = {
  viewId: number | undefined;
  refetchView: boolean;
  toggleRefetchView: () => void;
  refetchDropdownViews: boolean;
  toggleRefetchDropdownViews: () => void;
  recentlyViewedIds: string[];
  resetView: boolean;
  toggleResetView: () => void;
};

export const defaultViewContextState = {
  viewId: undefined,
  refetchView: false,
  toggleRefetchView: noop,
  refetchDropdownViews: false,
  toggleRefetchDropdownViews: noop,
  recentlyViewedIds: [],
  resetView: false,
  toggleResetView: noop,
};

export const ViewContext = createContext<ViewContextState>(defaultViewContextState);
export const useViewContext = () => useContext(ViewContext);
